import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';

import { login, clearLoginError } from '../../../Redux/user-profile/actions';
import { isLogin, isLoading, loginError } from '../../../Redux/user-profile/selectors';
import { withCapacitor } from '../../../Util/Capacitors/hoc';
import LoginView from './Login.view';

export default compose(
  connect(
    (state) => ({
      isLogin: isLogin(state),
      loginError: loginError(state),
      isLoading: isLoading(state),
    }),
    {
      login,
      clearLoginError,
    }
  ),
  branch(
    (props) => props.isLogin,
    renderComponent((props) => {
      const { from } = props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    })
  ),
  withCapacitor
)(LoginView);
